import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import InputField from '../../components/InputField';
import { BASVURU_HARCI, DELIL_TESPITI_HARCI, DURUSMA_MASRAFI_TARAF_SAYISI_TEMEL_UCRETI, DURUSMA_MASRAFI_TARAF_SAYISI_UCRET_ARTISI, HARC_ORANI, KARAR_HARCI_SABIT, MAHKEMELER, POSTA_MASRAFI_TEMEL, TARAF_SAYISI_POSTA_UCRET_ARTISI, VEKALET_SURET_HARCI, VEKALET_PULU, YURUTMENIN_DURDURULMASI_HARCI, PESIN_HARC_TEMEL, PESIN_HARC_TARAF_SAYISI_UCRET_ARTISI, BASVURU_HARCI_ICRA_SULH, GIDER_AVANSI_TEMEL } from '../../constants/constants';
import Dropdown from '../../components/Dropdown';
import Checkbox from '../../components/Checkbox';
import Header from '../../components/Header';

const faqs = [
    {
        question: "<h5>Gider Avansı Nedir?</h5>",
        answer: ["Gider avansı, dava açarken davacı tarafından mahkeme veznesine yatırılması gereken bir tutardır. Bu tutar, davayla ilgili tebligat, posta, keşif, bilirkişi incelemesi ve tanık dinleme gibi masrafları karşılamak için kullanılır."],
    },
    {
        question: "<h5>Gider Avansı Neye Göre Belirlenir?</h5>",
        answer: ["Gider avansı, her yıl Adalet Bakanlığı tarafından güncellenen \"Gider Avansı Tarifesi\"ne göre belirlenir."]
    },
    {
        question: "<h5>Gider Avansı İadesi</h5>",
        answer: ["Gider avansının kullanılmayan kısmı, davanın kesinleşmesinden sonra davacıya iade edilir. Davacı tarafından hesap numarası bildirilmiş ise iade elektronik ortamda yapılır. Hesap numarası bildirilmemiş ise iade PTT aracılığıyla davacının adresine gönderilir."]
    },
    {
        question: "<h5>Harç Nedir?</h5>",
        answer: ["Harç, devlet tarafından sunulan bir hizmet karşılığında ödenen bedeldir."]
    },
    {
        question: "<h5>Harç İadesi</h5>",
        answer: ["Bazı durumlarda ödenmiş olan harçlar iade edilebilir. Harç iadesi için, ilk derece vergi mahkemelerince verilen nihai kararlar üzerinden ödenmiş olan harçlar için mahkeme tarafından yargı çevresindeki Mal Müdürlüğü veya Defterdarlık Muhasebe Müdürlüğü'ne müzekkere yazılarak talimat verilmektedir. Uygulamada, mahkemece müzekkere yazıldıktan sonra ilgili idari kuruma tekrar başvuru yapılarak harç iadesi talep edilir. Harç iadesi, başvuru yapılmasının ardından yaklaşık üç ay içerisinde tamamlanır."]
    },
];

const MahkemeHarcGiderHesaplama = () => {
	const [hideAll, setHideAll] = useState(false);
	const [results, setResults] = useState([]);
	const [calculated, setCalculated] = useState(false);

    const [secilenMahkeme, setSecilenMahkeme] = useState(null);
    const [secilenDavaTuru, setSecilenDavaTuru] = useState(null);
    const [tutar, setTutar] = useState(null);
    const [yurutmeninDurdurulmasiTalebi, setYurutmeninDurdurulmasiTalebi] = useState(null);
    const [delilTespitiTalebi, setDelilTespitiTalebi] = useState(null);
    const [durusmaTalebi, setDurusmaTalebi] = useState(null);
    const [secilenHesaplamaTipi, setSecilenHesaplamaTipi] = useState(null);
    const [tarafSayisi, setTarafSayisi] = useState(null);

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
            const parseQueryParam = (key) => {
                const value = query.get(key);
                return value ? JSON.parse(decodeURIComponent(atob(value))) : null;
            };

			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}

            setSecilenMahkeme(parseQueryParam('secilenMahkeme'));
            setSecilenDavaTuru(parseQueryParam('secilenDavaTuru'));
            setTutar(parseQueryParam('tutar'));
            setYurutmeninDurdurulmasiTalebi(parseQueryParam('yurutmeninDurdurulmasiTalebi'));
            setDelilTespitiTalebi(parseQueryParam('delilTespitiTalebi'));
            setDurusmaTalebi(parseQueryParam('durusmaTalebi'));
            setSecilenHesaplamaTipi(parseQueryParam('secilenHesaplamaTipi'));
            setTarafSayisi(parseQueryParam('tarafSayisi'));

			setCalculated(true);
		}

		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
        if (!secilenMahkeme) {
            alert('Lütfen mahkemeyi seçin.');
            return;
        }

        if (tarafSayisi < 2) {
            alert('Taraf sayısı 2\'den az olamaz!');
            return;
        }

        // C veya D de dava türü zorunlu
        if (secilenMahkeme <= 2 && secilenDavaTuru === null) {
            alert('Lütfen dava türünü seçin.');
            return;
        }

        // A veya B de hesaplama tipi zorunlu
        if (secilenMahkeme > 2 && secilenHesaplamaTipi === null) {
            alert('Lütfen hesaplama tipini seçin.');
            return;
        }

        let newResults = [];

        // C veya D ise ortak olanları yap
        if (secilenMahkeme === 1 || secilenMahkeme === 2) {
            newResults = [
				{ text: "Başvurma Harcı", value: BASVURU_HARCI },
                { text: "Vekalet Suret Harcı", value: VEKALET_SURET_HARCI },
                { text: "Vekalet Pulu", value: VEKALET_PULU },

                // Y2
                { text: "Posta Masrafları", value: POSTA_MASRAFI_TEMEL + TARAF_SAYISI_POSTA_UCRET_ARTISI * (tarafSayisi - 2) },
			];

            if (yurutmeninDurdurulmasiTalebi === true) {
                newResults.push({ text: "Yürütmeyi Durdurma Harcı", value: YURUTMENIN_DURDURULMASI_HARCI });
            }

            if (delilTespitiTalebi === true) {
                newResults.push({ text: "Delil Tespit Harcı", value: DELIL_TESPITI_HARCI });
            }

            if (durusmaTalebi === true) {
                // Y3
                newResults.push({ text: "Duruşma Masrafı", value: DURUSMA_MASRAFI_TARAF_SAYISI_TEMEL_UCRETI + DURUSMA_MASRAFI_TARAF_SAYISI_UCRET_ARTISI * (tarafSayisi - 2) });
            }
        }

        // A veya B ise ortakları yap
        if (secilenMahkeme > 2) {
            newResults = [
                { text: "Vekalet Suret Harcı", value: VEKALET_SURET_HARCI },
                { text: "Vekalet Pulu", value: VEKALET_PULU },

                // X2
                { text: "Peşin Harç", value: PESIN_HARC_TEMEL + PESIN_HARC_TARAF_SAYISI_UCRET_ARTISI * (tarafSayisi - 2) },
			];

            // X1
            if (secilenHesaplamaTipi === 1) {
                // Nispi ise
                if (tutar === null || tutar <= 0) {
                    alert("Lütfen geçerli bir tutar giriniz.");
                    return;
                }

                newResults.push({ text: "Gider Avansı", value: Math.max(GIDER_AVANSI_TEMEL, tutar * HARC_ORANI) });
            } else {
                // Maktu ise
                newResults.push({ text: "Gider Avansı", value: GIDER_AVANSI_TEMEL });
            }
        }

        // C (İdari)
        if (secilenMahkeme === 1) {
            // Y1
            if (secilenDavaTuru === 1) {
                // Tam Yargı ise formula
                if (tutar === null && tutar <= 0) {
                    alert("Lütfen geçerli bir tutar giriniz.");
                    return;
                }

                newResults.push({ text: "Karar Harcı", value: Math.max(KARAR_HARCI_SABIT, tutar * HARC_ORANI) });
            } else {
                // İptal ise sabit
                newResults.push({ text: "Karar Harcı", value: KARAR_HARCI_SABIT });
            }
        }

        // D (Vergi)
        else if (secilenMahkeme === 2) {
            // DO NOTHING SINCE WE ALREADY DONE AT THE START
        }

        // B (İcra ve Sulh Hukuk)
        else if (secilenMahkeme === 8 || secilenMahkeme === 10) {
            newResults.push({ text: "Başvurma Harcı", value: BASVURU_HARCI_ICRA_SULH });
        }

        // A
        else {
            newResults.push({ text: "Başvurma Harcı", value: BASVURU_HARCI });
        }

        setHideAll(true);
        setResults(newResults);

        let total = 0;
        for (const result of newResults) {
            total += result.value;
        }

        newResults.push({ text: "Toplam", value: total });

        const params = new URLSearchParams({
            results: btoa(encodeURIComponent(JSON.stringify(newResults))),
            secilenMahkeme: btoa(encodeURIComponent(secilenMahkeme)),
            secilenDavaTuru: btoa(encodeURIComponent(secilenDavaTuru)),
            tutar: btoa(encodeURIComponent(tutar)),
            yurutmeninDurdurulmasiTalebi: btoa(encodeURIComponent(yurutmeninDurdurulmasiTalebi)),
            delilTespitiTalebi: btoa(encodeURIComponent(delilTespitiTalebi)),
            durusmaTalebi: btoa(encodeURIComponent(durusmaTalebi)),
            secilenHesaplamaTipi: btoa(encodeURIComponent(secilenHesaplamaTipi)),
            tarafSayisi: btoa(encodeURIComponent(tarafSayisi)),
        });        

        navigate(`${window.location.pathname}?${params.toString()}`);
        navigate(0);
	};

    return (
        <>
            <Helmet>
                <title>Mahkeme Harç ve Gider Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Mahkeme harç ve gider hesaplama, bir davanın açılması veya sürdürülmesi için gerekli olan maliyetleri belirlemek amacıyla yapılan bir işlemdir." />
            </Helmet>
            
            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>Mahkeme Harç ve Gider Hesaplama</li>
                    </ol>
                    <h1 className="fw-semibold">Mahkeme Harç ve Gider Hesapla</h1>
                    <p>Mahkeme harç ve gider hesaplama, bir davanın açılması veya sürdürülmesi için gerekli olan maliyetleri belirlemek amacıyla yapılan bir işlemdir.</p>

                    <Dropdown options={MAHKEMELER} selectedOption={secilenMahkeme} setSelectedOption={setSecilenMahkeme} label="Mahkeme Türünü Seçiniz" />

                    <InputField
                        trailText="taraf"
                        label="Taraf Sayısı"
                        setValue={setTarafSayisi}
                        value={tarafSayisi}
                        type="number"
                    />

                    {secilenMahkeme && secilenMahkeme <= 2 && (
                        // C veya D için
                        <>
                            <Dropdown
                                label="Dava Türü"
                                options={[
                                    { text: 'Tam Yargı', value: 1 },
                                    { text: 'İptal', value: 2 },
                                ]}
                                selectedOption={secilenDavaTuru}
                                setSelectedOption={setSecilenDavaTuru}
                            />

                            {secilenDavaTuru === 1 && secilenMahkeme === 1 && (
                                // C'de Tam Yargı seçilirse
                                <InputField
                                    trailText="TL"
                                    label="Tutar"
                                    setValue={setTutar}
                                    value={tutar}
                                    type="number"
                                />
                            )}

                            <Checkbox
                                label="Yürütmenin durdurulması talebi var ise burayı işaretleyiniz."
                                checkbox={yurutmeninDurdurulmasiTalebi}
                                setCheckbox={setYurutmeninDurdurulmasiTalebi}
                            />
                            
                            <Checkbox
                                label="Delil tespiti talebi var ise burayı işaretleyiniz."
                                checkbox={delilTespitiTalebi}
                                setCheckbox={setDelilTespitiTalebi}
                            />
                            
                            <Checkbox
                                label="Duruşma talebi var ise burayı işaretleyiniz."
                                checkbox={durusmaTalebi}
                                setCheckbox={setDurusmaTalebi}
                            />
                        </>
                    )}
                    {secilenMahkeme && secilenMahkeme > 2 && (
                        // A veya B
                        <>
                            <Dropdown
                                label="Hesaplama Tipi"
                                selectedOption={secilenHesaplamaTipi}
                                setSelectedOption={setSecilenHesaplamaTipi}
                                options={[
                                    { text: "Nispi", value: 1 },
                                    { text: "Maktu", value: 2 },
                                ]}
                            />

                            {secilenHesaplamaTipi && secilenHesaplamaTipi === 1 &&
                                // A veya B'de Nispi seçilirse
                                <InputField
                                    trailText="TL"
                                    label="Tutar"
                                    setValue={setTutar}
                                    value={tutar}
                                    type="number"
                                />
                            }
                        </>
                    )}
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} />
            </section>

            <Footer faqs={faqs} faqTitle="Mahkeme Harç ve Giderleri Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default MahkemeHarcGiderHesaplama;
